import React from "react";
import PropTypes from "prop-types";
import { itemLabel } from "./DataList.module.scss";

const Datum = ({ label, children }) => (
  <React.Fragment>
    <dt className={itemLabel}>{label}</dt>
    <dd>{children}</dd>
  </React.Fragment>
);

Datum.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node
};

export default Datum;
